<div fxLayout="row wrap">
  <div fxFlex.gt-sm="30" fxFlex.lt-sm="10"></div>
  <div fxFlex.gt-sm="40" fxFlex.lt-sm="80">
    <div class="feedback">
      <h3>Give us Feedback</h3>
      <p>We're constantly trying to improve our service, tell us how.</p>
      <br>

      <ng-container *ngIf="extra">
        <p [innerHtml]="extra"></p>
        <br>
      </ng-container>

      <mat-divider></mat-divider>
      <br>
      <div *ngIf="sent" class="success">
        <mat-icon>check</mat-icon>
        <p>Thank you for your feedback!</p>
      </div>
      <form [formGroup]="form" (ngSubmit)="ngSubmit(form);" *ngIf="!sent">
        <mat-form-field appearance="fill">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name">
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Email Address</mat-label>
          <input matInput formControlName="emailAddress" type="email">
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Message</mat-label>
          <textarea matInput formControlName="message"></textarea>
        </mat-form-field>
        <div style="text-align: right;">
          <button mat-raised-button color="accent" [disabled]="form.disabled">Submit</button>
        </div>
      </form>
    </div>
  </div>
  <div fxFlex.gt-sm="30" fxFlex.lt-sm="10"></div>
</div>
